export const addOfficeBtn = {
  marginLeft:'2em',
  marginBottom:'0.3em',
  backgroundColor: "#EC9324",
  padding: "4px",
  "&:hover, &:focus": {
    backgroundColor: "#EC9324",
  },
};

export const addIconStyle = { color: "white", fontSize: "18px" };
